import React from "react";
import { FC } from "react";
import { Button, Container, Navbar } from "react-bootstrap";
import { generateGUID } from "../util/Guid";
import { Goal } from "../types/Goal";
import { useNavigate } from "react-router-dom";
import { useCreateGoalMutation } from "../mutators/goal-mutators";

export const CreateGoalForm: FC = () => {
    const nav = useNavigate()
    const createGoalMutation = useCreateGoalMutation()
    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const title = (e.currentTarget.elements.namedItem('title') as HTMLInputElement).value

        const goal: Goal = {
            id: generateGUID(),
            title
        }

        await createGoalMutation.mutateAsync(goal)
        nav('/stats')
    }

    return (
        <>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h2 className="mb-0">Create Goal</h2>
                </Container>
            </Navbar>
            <Container>
                <form onSubmit={onSubmit}>
                    <div className="mb-3">
                        <label htmlFor="title" className="form-label fs-4">Goal</label>
                        <input type="text" className="form-control" id="title" />
                    </div>
                    <Button type="submit" className="w-100">Create Goal</Button>
                </form>
            </Container>
        </>
    )
} 